module.exports = __webpack_public_path__ + "static/media/splunk-trustar-white-logo.d390c308.png";